var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-tooltip",on:{"mouseenter":_vm.showTooltip,"mousemove":_vm.updatePosition,"mouseleave":_vm.hideTooltip}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }